import type { InjectionKey, Ref } from "vue";
import type { RouteLocationRaw } from "vue-router";

export const rowLinkToKey: InjectionKey<Ref<RouteLocationRaw>> = Symbol("rowLinkTo");
